import React from 'react';
import { ClientDashboardPage } from './pages';

export const DashboardPage = () => {
    return <ClientDashboardPage />;
};
